import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { setToken, setIsLoginCompleted, setUserInfo, setPermissions, setMerchantInfo } from './redux/userSlice'
// import { getPermissionsList, getUserList as getRoleList } from './api/roleApi';
import { getProfile, getMerchantInfo } from './api/loginApi';
import { useNavigate } from "react-router-dom";

function UserProvider() {

  const dispatch = useDispatch();
  const { isSignedIn } = useSelector((state) => state.user)
  const navigate = useNavigate();

  useEffect(() => {
    const loginToken = localStorage.getItem("ADMIN_LOGIN_TOKEN");
    if (loginToken) {
      getProfile().then(resProfile => {
        // console.log('resProfile res', resProfile);
        if (resProfile && resProfile.response.isSuccess) {
          dispatch(setUserInfo(resProfile.user))
          dispatch(setToken(loginToken))
          // dispatch(setIsLoginCompleted(true))
        } else {
          dispatch(setIsLoginCompleted(true))
        }

      }).catch(error => {
        console.error(error)
        dispatch(setIsLoginCompleted(true))
      })
    } else {
      navigate("/login", { replace: true });
    }

  }, []);

  useEffect(() => {

    if (isSignedIn) {
      getMerchantInfo().then(res => {
        if (res && res.merchant) {
          dispatch(setMerchantInfo(res.merchant))
        }
        else {
          dispatch(setMerchantInfo({}))
        }
      }).catch(error => {
        console.error(error)
      })
    }


  }, [isSignedIn])


  return (
    <></>
  );
}

export default UserProvider;
